import React, { useState, useEffect } from "react";
import { Row, Col, Avatar, Divider, Tooltip } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import { CustomSecondaryButton } from "../../physician_page/styled";

const AssisgnedVideoModal = ({ isOpen, setOpen, physicianData, memberType }) => {
  const isCoordinator = memberType === "coordinator";
  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={() => setOpen(false)}
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            {isCoordinator ? "Coordinator Details" : "Physician Details"}
          </h3>
          <span className="font-15 text-secondry">
            {isCoordinator
              ? "Here is the list of all the assigned coordinators."
              : "Here is the list of all the assigned physician."}
          </span>
        </div>
      }
      footer={null}
      width={650}
      keyClose={false}
      className="custom-detail-modal"
    >

      <div style={{ maxHeight: "320px", overflowY: "auto", overflowX: "hidden", marginBottom: "16px" }}>
        <Row gutter={[24, 24]}>
          {physicianData?.map((item) => (
            <Col
              span={12}
              key={item.id}
              className="ellipsis"
              style={{
                height: "100%",
                width: "100%"
              }}
            >
              <div 
                className="row-flex ellipsis cursor"
                style={{
                  backgroundColor: "var(--border-color)",
                  color: "var(--primary-text-color)",
                  borderRadius: "7px",
                  padding: "9px 5px",
                  width: "100%",
                  boxSizing: "border-box"
                }}
              >
              <div
                className="d-flex justify-content-center"
              >
                <Avatar
                  size={40}
                  style={{
                    marginRight: "8px",
                    backgroundColor: "var(--primary-bg)",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {capitalizeFirstLetter(item?.name?.[0])}
                </Avatar>
              </div>
              <div className="d-flex flex-column justify-content-center align-start">
                <span className="ellipsis" style={{width: "89%"}}>{capitalizeFirstLetter(item?.name)}</span>
                <Tooltip placement="top" title={item?.email}>
                <span className="ellipsis" style={{width: "89%"}}>{capitalizeFirstLetter(item?.email)}</span>
                </Tooltip>
                <span>Role: {item?.role}</span>
                <span>Specialty: {isCoordinator ? "CCM - Chronic Care Management" : capitalizeFirstLetter(item?.specialty)}</span>
              </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      <Row>
        <Col span={24} className="d-flex justify-content-center">
          <CustomSecondaryButton
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </CustomSecondaryButton>
        </Col>
      </Row>
    </AddPhysicianModalWrapper>
  );
};

export default AssisgnedVideoModal;
